import React from "react";
import "./Logo.css";

export default function logoImage() {
  return <img src="./images/logo.png" alt="logo" className="Logo" />;
}
